import React from 'react';
import reactDom from 'react-dom';

import Todo from'./component/todoreact/Todo.js';


reactDom.render(
  <>
  <Todo />
  </>
  ,document.getElementById('root')
  
)
